import React, { useEffect, useRef } from 'react';

declare global {
  interface Window { adsbygoogle: unknown[]; }
}

interface AdUnitProps {
  slot: string;
  className?: string;
  style?: React.CSSProperties;
}

const isLocalhost = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const AdUnit: React.FC<AdUnitProps> = ({ slot, className = '', style }) => {
  const pushed = useRef(false);
  useEffect(() => {
    if (pushed.current) return;
    pushed.current = true;
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch {}
  }, []);

  // Never render ad placeholders on localhost — AdSense won't serve and the
  // empty container creates a large blank space in the article layout.
  if (isLocalhost) return null;

  return (
    <div className={`adsense-container ${className}`}
      style={{ overflow: 'hidden', textAlign: 'center', ...style }}
      aria-label="Advertisement">
      <ins className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-6089816787582091"
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true" />
    </div>
  );
};

export default AdUnit;
